// extracted by mini-css-extract-plugin
export default {"container":"unavailable_container__qoRQv","imgContainer":"unavailable_imgContainer__BC2AG","header":"unavailable_header__G5rOO"};